import { ProfileUserSummaryRenderer } from "#webapp/src/components/profile-user-summary";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { useMonetization } from "../../../hooks/useMonetization";
import { TrialBannerSideMenu } from "../../trial-banner-sidemenu";
import { ChromeNavMenu } from "../ChromeNavMenu";
import { IProps as INavProps } from "../ChromeNavTypes";
import { ChromeNavBackBtn } from "./ChromeNavBackBtn";
import { ChromeNavGeneric } from "./ChromeNavGeneric";

interface Props {
  environment: INavProps["environment"];
  org?: INavProps["org"];
}

export const ChromeNavCalendarProfile = ({ org, environment }: Props) => {
  const mode = useSelector((state: IReduxState) => state.webExtension.mode);
  const { daysLeftInTrial, shouldUserSeeJoinExistingPlan } = useMonetization();

  const bannerIsVisible = daysLeftInTrial && daysLeftInTrial > 0;

  // Adds some extra space so the back arrow and banner dont overlap
  const buttonPositionBack = classNames("cw-absolute cw-left-0", {
    "cw-top-1": !bannerIsVisible,
    "cw-top-6": bannerIsVisible,
  });

  // Adds some extra space so the back arrow and banner dont overlap
  const buttonPositionOptions = classNames("cw-absolute cw-right-0", {
    "cw-top-1": !bannerIsVisible,
    "cw-top-6": bannerIsVisible,
  });

  if (!org || !environment) {
    return (
      <ChromeNavGeneric
        backDestination={ChromeAppWrapperView.TeamHealth}
        label="Profile"
        settings
        editTeam
        feedback
      />
    );
  }

  return (
    <>
      <TrialBannerSideMenu
        daysLeft={daysLeftInTrial}
        showJoinExistingPlan={shouldUserSeeJoinExistingPlan}
      />
      <div className="cw-flex cw-justify-center cw-p-4">
        <div className={buttonPositionBack}>
          <ChromeNavBackBtn backDestination={ChromeAppWrapperView.TeamHealth} />
        </div>
        <ProfileUserSummaryRenderer orgRelayId={org.id} environment={environment} />
        <div className={buttonPositionOptions}>
          {mode === "extension" ? <ChromeNavMenu settings feedback /> : null}
        </div>
      </div>
    </>
  );
};
